import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class OptionalColumnsMixin extends Vue {
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

  public get isPlottedLocationFeatureEnabled(): boolean {
    return !!this.getFeature(["Devices", "AdvancedSetup", "Columns", "Plotted"]);
  }

  public get isOptionalColumnsFeatureEnabled(): boolean {
    return !!this.getFeature(["Devices", "AdvancedSetup", "Columns"]);
  }

  public get isGroupSyncColumnEnabled(): boolean {
		return !!this.getFeature(["Devices", "AdvancedSetup", "Columns", "AreaSync"]);
	}
}